import React, { useState, useRef, useEffect } from 'react';
import './Registro.css';
import logo from '../assets/Logo_SALVIR.png';
import logo2 from '../assets/Logo_SALVIR_letras.png';
import { registerMedico } from "../services/auth"; // ✅ Usamos la función correcta
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { sendEvent } from "../utils/ga4"; 
import { sendMetaEvent } from "../utils/metaPixel";

// 🚫 Dominios de correos temporales / basura
const TEMP_EMAIL_DOMAINS = [
  "mailinator.com",
  "tempmail.com",
  "10minutemail.com",
  "guerrillamail.com",
  "guerrillamail.de",
  "guerrillamail.net",
  "guerrillamail.org",
  "guerrillamail.info",
  "guerrillamail.biz",
  "yopmail.com",
  "yopmail.fr",
  "yopmail.net",
  "cool.fr.nf",
  "jetable.fr.nf",
  "courriel.fr.nf",
  "moncourrier.fr.nf",
  "monemail.fr.nf",
  "monmail.fr.nf",
  "hide.biz.st",
  "mymail.infos.st",
  "nespj.com",
  "roastic.com",
  "techmexsolutions.com",
  "techmexsolution.com",
  "sistemas.mx",
  "sistemas.com",
  "passinbox.com",

  // comunes de temp/disposable
  "sharebot.net",
  "sharebot.com",
  "mail.sharebot.net",
  "sharebot.xyz",
  "grr.la",
  "guerrillamailblock.com",
  "sharklasers.com",
  "spam4.me",
  "bccto.me",
  "chacuo.net",
  "dispostable.com",
  "fakeinbox.com",
  "getairmail.com",
  "getnada.com",
  "maildrop.cc",
  "mailnesia.com",
  "mintemail.com",
  "moakt.com",
  "mytemp.email",
  "temp-mail.org",
  "temp-mail.io",
  "tempmailo.com",
  "tempail.com",
  "throwawaymail.com",
  "trashmail.com",
  "trashmail.de",
  "trashmail.fr",
  "trashmail.me",
  "trashmail.net",
  "wegwerfmail.de",
  "wegwerfmail.net",
  "wegwerfmail.org",
  "spamgourmet.com",
  "emailondeck.com",
  "smailpro.com",
  "mintemail.net",
  "disposablemail.com",
  "mailinator.net",
  "mailinator.org",
  "mailinator2.com",
  "mailcatch.com",
  "mail-temporaire.fr",
  "temporary-mail.net",
  "tmpmail.org",
  "tmpeml.com",
  "tempr.email",
  "fakemail.net",
  "dropmail.me",
  "dropmail.ml",
  "harakirimail.com",
  "incognitomail.org",
  "spamavert.com",
  "spambog.com",
  "spambog.de",
  "spambog.ru",
  "spambox.info",
  "spambox.irishspringrealty.com",
  "mailnull.com",
  "nowmymail.com",
  "objectmail.com",
  "proxymail.eu",
  "rcpt.at",
  "trash2009.com",
  "zoemail.net",
];

// ⚠️ Typos comunes en dominios reales
const EMAIL_DOMAIN_TYPOS = {
  "gmal.com": "gmail.com",
  "gmial.com": "gmail.com",
  "gamil.com": "gmail.com",
  "gmai.com": "gmail.com",
  "gmail.con": "gmail.com",
  "hotnail.com": "hotmail.com",
  "hotmal.com": "hotmail.com",
  "hotmial.com": "hotmail.com",
  "outlok.com": "outlook.com",
  "outllok.com": "outlook.com",
  "outloo.com": "outlook.com",
  "icloud.con": "icloud.com",
  "yaho.com": "yahoo.com",
  "yhoo.com": "yahoo.com",
};

const getSuggestedEmailDomain = (email) => {
  if (!email || !email.includes("@")) return null;

  const parts = email.toLowerCase().trim().split("@");
  if (parts.length !== 2) return null;

  const domain = parts[1];
  return EMAIL_DOMAIN_TYPOS[domain] || null;
};

// 🚫 Validaciones básicas de correo basura
const isSuspiciousEmail = (email) => {
  if (!email || !email.includes("@")) return true;

  const [user, domain] = email.toLowerCase().split("@");

   // Dominio temporal conocido
  if (
    TEMP_EMAIL_DOMAINS.some(
      blocked => domain === blocked || domain.endsWith(`.${blocked}`)
    )
  ) return true;

  // Usuario solo números (ej. 730@)
  if (/^\d+$/.test(user)) return true;

  // Usuario largo sin vocales (bots)
  if (user.length > 15 && !/[aeiou]/i.test(user)) return true;

  return false;
};

const TURNSTILE_SITE_KEY =
  process.env.REACT_APP_TURNSTILE_SITE_KEY;

function Registro() {
  const [showPassword, setShowPassword] = useState(false);
  const [especialidadTouched, setEspecialidadTouched] = useState(false);
  const [formData, setFormData] = useState({
    nombre: "",
    apellido_paterno: "",
    apellido_materno: "",
    email: "",
    telefono: "",
    especialidad: "Médico General",
    sexo: "",
    password1: "",
    password2: "",
  });
  const navigate = useNavigate();
  
  const turnstileToken = useRef(null);
  const widgetContainer = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    const render = () => {
      if (window.turnstile && widgetContainer.current && widgetId.current === null) {
        widgetId.current = window.turnstile.render(widgetContainer.current, {
          sitekey: TURNSTILE_SITE_KEY,
          appearance: "interaction-only",
          callback: (token) => { turnstileToken.current = token; },
          "error-callback": () => { turnstileToken.current = null; },
          "expired-callback": () => { turnstileToken.current = null; },
        });
      }
    };
    if (window.turnstile) {
      render();
    } else {
      const interval = setInterval(() => {
        if (window.turnstile) { render(); clearInterval(interval); }
      }, 200);
      return () => clearInterval(interval);
    }
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Manejar cambios en los inputs
  const handleChange = (e) => {
  if (!window._formStarted) {
    window._formStarted = true;
    sendEvent({
      category: "Registro",
      action: "Inicio_formulario_Registro",
      label: "InicioFormularioRegistro",
    });
  }

  setFormData({
    ...formData,
    [e.target.name]: e.target.value
  });

    if (e.target.name === "especialidad") {
      setEspecialidadTouched(true);
    }
  };

  // Validación de contraseña
const validatePassword = (password) => {
  const minLength = password.length >= 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return minLength && hasUpperCase && hasNumber && hasSpecialChar;
};


  const handleSubmit = async (event) => {
    event.preventDefault();

    // 🚨 Verificar si las contraseñas coinciden antes de enviar la solicitud
    if (formData.password1 !== formData.password2) {
      toast.error("Las contraseñas no coinciden. Inténtalo de nuevo.");
      return;
    }

      // 🔒 Validar complejidad de contraseña
    if (!validatePassword(formData.password1)) {
      toast.error(
        "La contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un carácter especial."
      );
      return;
    }
    
    // 🚨 Bloqueo de correos temporales / bots
    if (isSuspiciousEmail(formData.email)) {
      toast.error(
         "Por favor usa un correo electrónico real o contacta a soporte."
      );
      return;
    }

    const suggestedDomain = getSuggestedEmailDomain(formData.email);
    if (suggestedDomain) {
      const [user] = formData.email.toLowerCase().trim().split("@");
      toast.error(
        `Verifica tu correo. ¿Quisiste escribir ${user}@${suggestedDomain}?`
      );
      return;
    }

    // Alerta si el usuario no ha cambiado la especialidad
    if (!especialidadTouched) {
      const confirmacion = window.confirm(
        "No seleccionaste una especialidad. Se guardará tu perfil como Médico General. ¿Quieres continuar?"
      );
      if (!confirmacion) return;
    }

    try {
       // 🔒 Verificar que Turnstile ya dio token antes de enviar
      if (!turnstileToken.current) {
        toast.error("Por favor completa la verificación de seguridad.");
        return;
      }
      const response = await registerMedico({
        ...formData,
        cf_turnstile_response: turnstileToken.current,
      });
      
      if (response) {
        sendEvent({
          category: "Registro",
          action: "Registro_completado_exitosamente",
          label: "FormularioRegistroExitoso",
        });
        sendMetaEvent("CompleteRegistration");
        toast.success("Registro exitoso, te hemos enviado un correo de verificación, ahora inicia sesión..");
        setFormData({
          nombre: "",
          apellido_paterno: "",
          apellido_materno: "",
          email: "",
          telefono: "",
          especialidad: "Médico General",
          password: "",
          password2: "",
        });
        setTimeout(() => {
          navigate('/login');  // Ruta a la que lo quieres mandar después de registrarse
        }, 100);  // 1.5 segundos de delay para que vea el toast
      } else {
        alert("Error en el registro. Inténtalo de nuevo.");
      }
    } catch (error) {
      console.error("Error en el registro:", error);
      if (error.response) {
        
        alert("Error en el registro:\n" + JSON.stringify(error.response.data, null, 2));
      } else {
        alert("Error desconocido. Por favor contacta a soporte");
      }
    }}

  return (
    <div className="registro-container">
      <div className="logo-container">
        <div className="logo-wrapper">
        <img src={logo} alt="Logo" className="logo" />
        <img src={logo2} alt="Salvir Logo" className="logo2" />
        </div>
      </div>
      <div className="bienvenida-header">
        <h1>¡Bienvenido a Salvir!</h1>
      </div>

      <div className="registro-header">
        <p><strong>Importante:</strong> </p> 
        <p>
          Tus datos están <strong>100% protegidos</strong>: utilizamos servidores de <strong>Amazon Web Services (AWS)</strong> para garantizar la seguridad y confidencialidad de tu información, tus expedientes clínicos están protegidos con cifrado avanzado y controles de acceso. <strong>ni siquiera Salvir puede acceder a tus expedientes clínicos o recetas.</strong> Al registrarte, recibirás <strong>10 días gratis</strong>.  
          Una vez finalizado el periodo, podrás seleccionar el plan que mejor se adapte a ti. Para completar tu registro, será necesario que aceptes nuestros{' '}
           <a href="/terminos-y-condiciones" target="_blank" rel="noopener noreferrer">
            <strong>Términos y Condiciones</strong>
          </a>{' '}
          así como el{' '}
          <a href="/aviso-de-privacidad" target="_blank" rel="noopener noreferrer">
            <strong>Aviso de Privacidad</strong>
          </a>.
        </p>
        <p>Para comenzar, por favor completa el siguiente formulario:</p>
      </div>
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="required">Nombre</label>
            <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} required />

            <label className="required">Apellido Paterno</label>
            <input type="text" name="apellido_paterno" value={formData.apellido_paterno} onChange={handleChange} required />

            <label className="required">Apellido Materno</label>
            <input type="text" name="apellido_materno" value={formData.apellido_materno} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label className="required">Correo Electrónico</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>

          <div className="form-group">
            <label className="required">Teléfono Celular</label>
            <input type="tel" name="telefono" value={formData.telefono} onChange={handleChange} required pattern="[0-9]{10}" placeholder="10 dígitos" />
          </div>

          <div className="form-group">
            <label className="required">Especialidad</label>
            <select name="especialidad" value={formData.especialidad} onChange={handleChange} required>
            <option value="Médico General">Médico General</option>
              <option value="Alergología">Alergología</option>
              <option value="Anatomía Patológica">Anatomía Patológica</option>
              <option value="Anestesiología">Anestesiología</option>
              <option value="Angiología">Angiología</option>
              <option value="Cardiología">Cardiología</option>
              <option value="Cirugía Cardiovascular">Cirugía Cardiovascular</option>
              <option value="Cirugía General">Cirugía General</option>
              <option value="Cirugía Maxilofacial">Cirugía Maxilofacial</option>
              <option value="Cirugía Pediátrica">Cirugía Pediátrica</option>
              <option value="Cirugía Plástica y Reconstructiva">Cirugía Plástica y Reconstructiva</option>
              <option value="Cirugía Torácica">Cirugía Torácica</option>
              <option value="Cirugía Vascular">Cirugía Vascular</option>
              <option value="Coloproctología">Coloproctología</option>
              <option value="Dermatología">Dermatología</option>
              <option value="Endocrinología">Endocrinología</option>
              <option value="Gastroenterología">Gastroenterología</option>
              <option value="Genética Médica">Genética Médica</option>
              <option value="Geriatría">Geriatría</option>
              <option value="Ginecología y Obstetricia">Ginecología y Obstetricia</option>
              <option value="Hematología">Hematología</option>
              <option value="Infectología">Infectología</option>
              <option value="Medicina Crítica">Medicina Crítica</option>
              <option value="Medicina del Deporte">Medicina del Deporte</option>
              <option value="Medicina Familiar">Medicina Familiar</option>
              <option value="Medicina Física y Rehabilitación">Medicina Física y Rehabilitación</option>
              <option value="Medicina General">Medicina General</option>
              <option value="Medicina Interna">Medicina Interna</option>
              <option value="Medicina Legal y Forense">Medicina Legal y Forense</option>
              <option value="Medicina Nuclear">Medicina Nuclear</option>
              <option value="Medicina Preventiva y Salud Pública">Medicina Preventiva y Salud Pública</option>
              <option value="Nefrología">Nefrología</option>
              <option value="Neumología">Neumología</option>
              <option value="Neurocirugía">Neurocirugía</option>
              <option value="Neurología">Neurología</option>
              <option value="Nutrición Clínica">Nutrición Clínica</option>
              <option value="Oftalmología">Oftalmología</option>
              <option value="Oncología Médica">Oncología Médica</option>
              <option value="Oncología Quirúrgica">Oncología Quirúrgica</option>
              <option value="Ortopedia y Traumatología">Ortopedia y Traumatología</option>
              <option value="Otorrinolaringología">Otorrinolaringología</option>
              <option value="Pediatría">Pediatría</option>
              <option value="Psiquiatría">Psiquiatría</option>
              <option value="Radiología">Radiología</option>
              <option value="Reumatología">Reumatología</option>
              <option value="Toxicología">Toxicología</option>
              <option value="Urología">Urología</option>
            </select>
          </div>
          {/*<div className="form-group">
            <label>Sexo</label>
            <select name="sexo" value={formData.sexo} onChange={handleChange}>
              <option value="">Selecciona tu sexo</option>
            <option value="Hombre">Hombre</option>
            <option value="Mujer">Mujer</option>
            <option value="No binario">No binario</option>
            </select>
          </div>*/}

          <div className="form-group">
            <label className="required">Contraseña</label>
            <div className="password-container">
              <input 
                type={showPassword ? "text" : "password"} 
                name="password1" 
                value={formData.password1}
                onChange={handleChange}
                required 
              />
              <button type="button" onClick={togglePasswordVisibility} className="password-toggle">
                {showPassword ? "Ocultar" : "Mostrar"}
              </button>
              
            </div>
          </div>

          <div className="form-group">
            <label className="required">Confirmar Contraseña</label>
            <div className="password-container">
              <input 
                type={showPassword ? "text" : "password"} 
                name="password2" 
                value={formData.password2}
                onChange={handleChange}
                required 
              />
              <button type="button" onClick={togglePasswordVisibility} className="password-toggle">
                {showPassword ? "Ocultar" : "Mostrar"}
              </button>
            </div>
          </div>

            {/* Términos y condiciones */}
          <div className="terms-container"> 
            <input type="checkbox" name="terminos" required />
            <label>
             Acepto los&nbsp;
           <a href="/terminos-y-condiciones" target="_blank" rel="noopener noreferrer">
            Términos y Condiciones
          </a>
          &nbsp;y el&nbsp;
          <a href="/aviso-de-privacidad" target="_blank" rel="noopener noreferrer">
            Aviso de Privacidad
          </a>
            </label>
          </div>

            {/* Widget de Turnstile */}
          <div className="form-group">
            <div ref={widgetContainer}></div>
          </div>

           <button type="submit" onClick={() =>
            sendEvent({
            category: "Registro",
            action: "Click_botón_registro",
            label: "FormularioRegistroBoton",
            })
            }
            >Registrarse</button>
        </form>
      </div>
    </div>
  );
}

export default Registro;
